import { Button } from "../ui/button";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";

import { Checkbox } from "../ui/checkbox";
import { useState } from "react";
import React from "react";

export function SubmitBidDialog({ onSubmit }: { onSubmit: () => void }) {
    const [checked, setChecked] = useState(false);

    const handleChange = (event: any) => {
        setChecked(!checked);
    };

    const handleSubmit = () => {
        //console.log('submitting bid')
        onSubmit();
    };
    return (
        <Dialog>
            <DialogTrigger asChild>
                <Button>Submit Bid</Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>Submit Bid</DialogTitle>
                    <DialogDescription>
                        By submitting this bid, you agree to the terms and
                        conditions ... MARVIN TO WRITE THIS Once submitted, you
                        will not be able to edit this bid.
                    </DialogDescription>
                </DialogHeader>
                <div className=" ">
                    <br />
                    <div className="flex items-center space-x-2">
                        <Checkbox id="terms" onCheckedChange={handleChange} />
                        <label
                            htmlFor="terms"
                            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        >
                            Accept terms and conditions
                        </label>
                    </div>
                    <br />
                </div>
                <DialogFooter className="sm:justify-start">
                    <DialogClose asChild>
                        <Button
                            type="button"
                            variant="secondary"
                            onClick={handleSubmit}
                            disabled={!checked}
                            id="submitBidDialog"
                        >
                            Submit Bid
                        </Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
